import Logo from 'assets/icons/logo.png';

const ReviewOrder = () => {
  return (
    <div className="px-4 pt-6 pb-[150px] lg:mt-10 lg:w-[95%] lg:self-start lg:rounded-2xl lg:p-8 lg:shadow-order">
      <div className="flex items-center rounded-lg bg-background-light-blue p-4 lg:p-6">
        <img
          alt=""
          src={Logo}
          className="h-[41px] w-[33px] lg:h-[50px] lg:w-[45px]"
        />
        <div className="ml-4 lg:ml-5">
          <p className="text-sm font-semibold text-primary-black lg:text-base">
            Review your order
          </p>
          <p className="mt-1 text-xs text-primary-grey lg:text-sm">
            Check your order details and continue to payment
          </p>
        </div>
      </div>

      <p className="mt-6 hidden text-base font-semibold text-primary-black lg:block">
        Website
      </p>

      <div className="mt-6 rounded-xl border border-t-neutral-200 p-4 lg:p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-semibold text-primary-black lg:text-base">
              Landing page
            </p>
            <p className="mt-1 text-xs text-primary-grey lg:text-sm">
              Up to 1000 words and 8 images. Includes 2 revisions
            </p>
            <p className="mt-3 text-xs text-primary-black lg:text-sm">
              Layout #1
            </p>
          </div>
          <p className="text-sm font-bold text-primary-black lg:text-base">
            ₣2000
          </p>
        </div>

        <div className="my-4 w-full border-b border-[#E4EBF5]" />

        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-semibold text-primary-black lg:text-base">
              Additional Pages
            </p>
            <p className="mt-1 text-xs text-primary-grey lg:text-sm">
              Up to 500 words and 5 images. Includes 2 revisions
            </p>
            <p className="mt-3 text-xs text-primary-black">1 page</p>
          </div>
          <p className="text-sm font-bold text-primary-black lg:text-base">
            ₣200
          </p>
        </div>
      </div>

      <div className="mt-6 rounded-xl border border-t-neutral-200 p-4 lg:p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-semibold text-primary-black lg:text-base">
              Brand Identity
            </p>
            <p className="mt-1 text-xs text-primary-grey lg:text-sm">
              Logo, color theme, font & brand guideline. Includes 2 revisions
            </p>
          </div>
          <p className="text-sm font-bold text-primary-black lg:text-base">
            ₣1000
          </p>
        </div>

        <div className="my-4 w-full border-b border-[#E4EBF5]" />

        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-semibold text-primary-black lg:text-base">
              1 Year Web Hosting
            </p>
            <p className="mt-1 text-xs text-primary-grey lg:text-sm">
              Renew on January 15, 2024
            </p>
          </div>
          <p className="text-sm font-bold text-primary-black">₣2000</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewOrder;
